import { z } from 'zod';
import { WorkspaceId, ArtistId, GigId, AuditEventId } from '../ids.js';
import { IsoTimestamp } from '../primitives.js';
import { ActorType, RiskLevel } from '../enums.js';

/** §27.24 AuditEvent — immutable record of security-sensitive/financial/config/live-state actions. */
export const AuditEvent = z.object({
  auditEventId: AuditEventId,
  workspaceId: WorkspaceId,
  artistId: ArtistId.nullable().default(null),
  gigId: GigId.nullable().default(null),
  actorType: ActorType,
  actorId: z.string().nullable().default(null),
  action: z.string().min(1),
  targetType: z.string().min(1),
  targetId: z.string().min(1),
  riskLevel: RiskLevel.default('low'),
  requestId: z.string().nullable().default(null),
  idempotencyKey: z.string().nullable().default(null),
  beforeHash: z.string().nullable().default(null),
  afterHash: z.string().nullable().default(null),
  safeSummary: z.string().max(500),
  createdAt: IsoTimestamp,
});
export type AuditEvent = z.infer<typeof AuditEvent>;
